import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import { HelpCircle, History, PlusIcon } from "lucide-react";

type ChecklistsToolbarProps = {
  canManage: boolean;
  onCreate: () => void;
  onCopy?: (id: string) => void;
  onStartTour?: () => void;
};

export function ChecklistsToolbar({
  canManage,
  onCreate,
  onStartTour,
}: ChecklistsToolbarProps) {
  const nav = useNavigate();

  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between space-y-2">
        <div>
          <div className="flex items-center space-x-2">
            <h2 className="font-bold text-2xl tracking-tight">Checklist</h2>

            <Button
              variant="ghost"
              size="icon"
              className="size-7 rounded-full"
              onClick={onStartTour}
            >
              <HelpCircle className="size-5" />
            </Button>
          </div>
          <p className="text-muted-foreground">
            ຈັດການລາຍການກວດສອບ (Checklist).
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="outline"
            onClick={() => nav({ to: "/app/checklists/execution-history" })}
          >
            <History className="mr-2 h-4 w-4" />
            ປະຫວັດການບັນທຶກ
          </Button>
          {canManage && (
            <div data-tourid="checklist-toolbar">
              <Button onClick={onCreate}>
                <PlusIcon className="h-4 w-4" />
                ສ້າງ Checklist
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
